/**
 * Create a sort function for objects to sort by property value (ascending)
 * @param {string} prop
 * @returns {Function}
 */
export const sorter =
    (
        prop: string,
    ): ((
        a: Record<string, number | any>,
        b: Record<string, number | any>,
    ) => number) =>
    (a: Record<string, number>, b: Record<string, number>): number =>
        a[prop] - b[prop];
